(function() {
  if (window._customFiltersLoaded) return;
  window._customFiltersLoaded = true;
  document.addEventListener('DOMContentLoaded', function() {
    var productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    var productItems = productGrid.querySelectorAll('li.column');

    // Extract rack count from product titles and set data-rackcount
    var rackCounts = [];
    productItems.forEach(function(item) {
      var titleEl = item.querySelector('a.product-card-title');
      if (titleEl) {
        var title = titleEl.textContent.trim();
        var match = title.match(/\bof\s+(\d+)/i);
        if (match) {
          item.dataset.rackcount = match[1];
          var num = parseInt(match[1]);
          if (rackCounts.indexOf(num) === -1) rackCounts.push(num);
        }
      }
    });

    // Build # of Racks filter UI dynamically
    if (rackCounts.length > 0) {
      rackCounts.sort(function(a, b) { return a - b; });

      var filterHTML = '<collapsible-row><details class="thb-filter js-filter" open>' +
        '<summary class="thb-filter-title"><span></span># of Racks</summary>' +
        '<div class="thb-filter-content collapsible__content">' +
        '<ul class="thb-filter-list no-bullets" style="list-style:none;padding:0;margin:0;">';

      rackCounts.forEach(function(rc) {
        filterHTML += '<li style="margin-bottom:6px;">' +
          '<input type="checkbox" class="custom-checkbox custom-option-filter-checkbox" ' +
          'id="filter-rackcount-' + rc + '" data-option="rackcount" data-value="' + rc + '">' +
          '<label for="filter-rackcount-' + rc + '">' + rc + '</label></li>';
      });

      filterHTML += '</ul></div></details></collapsible-row>';

      // Insert into custom-option-filters containers
      document.querySelectorAll('.custom-option-filters').forEach(function(container) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = filterHTML;
        while (wrapper.firstChild) container.appendChild(wrapper.firstChild);
      });
    }

    // Filtering logic
    function getActiveFilters() {
      var filters = {};
      document.querySelectorAll('.custom-option-filter-checkbox').forEach(function(cb) {
        if (cb.checked) {
          var opt = cb.dataset.option;
          if (!filters[opt]) filters[opt] = [];
          filters[opt].push(cb.dataset.value);
        }
      });
      return filters;
    }

    function applyFilters() {
      var filters = getActiveFilters();
      var keys = Object.keys(filters);
      var hasFilters = keys.length > 0;

      productItems.forEach(function(item) {
        if (!hasFilters) {
          item.style.display = '';
          return;
        }

        var show = true;
        for (var k = 0; k < keys.length; k++) {
          var optionName = keys[k];
          var selectedValues = filters[optionName];
          var productValues = optionName === 'rackcount'
            ? (item.dataset.rackcount || '')
            : (item.dataset['option' + optionName.replace(/-/g, '')] || '');
          if (!productValues) {
            show = false;
            break;
          }
          var prodVals = productValues.split(',');
          var matched = false;
          for (var s = 0; s < selectedValues.length; s++) {
            if (prodVals.indexOf(selectedValues[s]) !== -1) {
              matched = true;
              break;
            }
          }
          if (!matched) {
            show = false;
            break;
          }
        }
        item.style.display = show ? '' : 'none';
      });

      updateFilterPills(filters);
    }

    function updateFilterPills(filters) {
      var pillContainer = document.querySelector('.custom-filters-active');
      if (!pillContainer) {
        pillContainer = document.createElement('div');
        pillContainer.className = 'custom-filters-active';
        var facetsBar = productGrid.closest('.sidebar-container');
        if (facetsBar) {
          var lastDiv = facetsBar.querySelector('div:last-child');
          if (lastDiv) lastDiv.prepend(pillContainer);
        }
      }
      pillContainer.innerHTML = '';
      var optionNames = Object.keys(filters);
      for (var i = 0; i < optionNames.length; i++) {
        var optionName = optionNames[i];
        var values = filters[optionName];
        for (var j = 0; j < values.length; j++) {
          var val = values[j];
          var pill = document.createElement('span');
          pill.className = 'custom-filter-pill';
          pill.innerHTML = val + ' <span class="remove">&times;</span>';
          (function(on, v) {
            pill.addEventListener('click', function() {
              var cb = document.querySelector(
                '.custom-option-filter-checkbox[data-option="' + on + '"][data-value="' + v + '"]'
              );
              if (cb) {
                cb.checked = false;
                var swatch = cb.closest('.thb-filter-swatch-container');
                if (swatch) swatch.classList.remove('active');
              }
              applyFilters();
            });
          })(optionName, val);
          pillContainer.appendChild(pill);
        }
      }
    }

    // Event delegation for dynamically-added checkboxes
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('custom-option-filter-checkbox')) {
        applyFilters();
      }
    });

    // Handle swatch clicks
    var swatchContainers = document.querySelectorAll('.thb-filter-swatch-container');
    swatchContainers.forEach(function(container) {
      container.addEventListener('click', function(e) {
        e.preventDefault();
        var cb = this.querySelector('input[type="checkbox"]');
        cb.checked = !cb.checked;
        this.classList.toggle('active', cb.checked);
        applyFilters();
      });
    });
  });
})();
